<template>
  <div class="wrapper">
    <parallax
      class="section page-header header-filter"
      :style="headerStyle"
    ></parallax>
    <div class="main main-raised">
      <div class="section profile-content">
        <div class="container">
          <div class="md-layout">
            <div class="md-layout-item md-size-50 mx-auto">
              <div class="profile">
                <div class="avatar">
                  <img
                    :src="img"
                    alt="Circle Image"
                    class="img-raised rounded img-fluid"
                    style="background: white;"
                  />
                </div>
                <div class="name">
                  <h3 class="title">Apoyo a Cursos</h3>
                </div>
              </div>
            </div>
          </div>
          <div class="md-layout-item md-size-100 mx-auto">
            <div class="table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    
                    <th scope="col">Nombre del curso</th>
                    <th scope="col">Descripción</th>
                    <th scope="col">Actividades realizadas</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                   
                    <td>Diplomado en Meteorología CCA UNAM</td>
                    <td>4 módulos, 120 hrs</td>
                    <td>
                      <ul>
                        <li>Apoyo en la configuración chromebooks</li>

                        <li>
                          Instalación de librerías especializadas para el
                          procesamiento y visualización datos
                        </li>
                        <li>Apoyo en el uso de los equipos</li>
                      </ul>
                    </td>
                  </tr>
                  <tr>
                    
                    <td>Taller sobre metodologías para el estudio de ondas de calor</td>
                    <td>En este taller se expondrán los conceptos básicos de climatología y estadística para entender el fenómeno de las olas de calor</td>
                    <td>Apoyo en la Configuración del servidor Jupiter2 en donde se instaló RStudio y demás librerías utilizadas
para el procesamiento y gratificación de los casos de estudio</td>
                  </tr>
                  
                </tbody>
              </table>
            </div>
            <br />
            <br />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Tabs } from "@/components";
export default {
  components: {},
  bodyClass: "profile-page",
  data() {},
  props: {
    header: {
      type: String,
      default: require("@/assets/img/vue-mk-header.jpg"),
    },
    img: {
      type: String,
      default: require("@/assets/img/curse.png"),
    },
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.section {
  padding: 0;
}
</style>
